import React, { useState } from 'react';
import { Link } from 'react-router-dom';

// SEO: Car data with rich descriptions for search engines
const cars = [
  {
    id: 1,
    name: 'Maruti Swift Dzire',
    type: 'Sedan',
    fuel: 'Petrol/Diesel',
    seating: '4+1',
    transmission: 'Manual/Auto',
    image: '/assets/img/car/dzire.png',
    link: '/swift-dzire',
    features: ['Airbags', 'ABS', 'Power Steering', 'Music System', 'Reverse Camera']
  },
  {
    id: 2,
    name: 'Maruti Ertiga',
    type: 'MUV',
    fuel: 'Petrol/CNG',
    seating: '6+1',
    transmission: 'Manual/Auto',
    image: '/assets/img/car/ertiga.png',
    link: '/maruti-ertiga',
    features: ['Airbags', 'ABS', 'EBD', 'Touchscreen', 'Climate Control']
  },
  {
    id: 3,
    name: 'Toyota Innova Crysta',
    type: 'MPV',
    fuel: 'Diesel',
    seating: '7+1',
    transmission: 'Manual/Auto',
    image: '/assets/img/car/crysta.png',
    link: '/innova-crysta',
    features: ['7 Airbags', 'ABS', 'EBD', 'Leather Seats', 'Sunroof', 'Navigation']
  },
  {
    id: 4,
    name: 'Force Urbania',
    type: 'Luxury Van',
    fuel: 'Diesel',
    seating: '13+1',
    transmission: 'Manual',
    image: '/assets/img/car/arban.jpg',
    link: '/force-urbania',
    features: ['AC', 'LED Lights', 'Premium Interiors', 'Entertainment System']
  },
  {
    id: 5,
    name: 'Tempo Traveller',
    type: 'Mini Bus',
    fuel: 'Diesel',
    seating: '17+1',
    transmission: 'Manual',
    image: '/assets/img/car/traveller.png',
    link: '/tempo-traveller',
    features: ['AC', 'Pushback Seats', 'Music System', 'WiFi Available']
  },
  {
    id: 6,
    name: '56-Seater Bus',
    type: 'Bus',
    fuel: 'Diesel',
    seating: '56',
    transmission: 'Manual',
    image: '/assets/img/car/bus.png',
    link: '/bus-56seater',
    features: ['AC/Non-AC', 'Pushback Seats', 'Lavatory', 'Entertainment', 'Luggage Space']
  }
];

const carTypes = ['All', 'Sedan', 'MUV', 'MPV', 'Luxury Van', 'Mini Bus', 'Bus'];

const CarList = () => {
  const [activeFilter, setActiveFilter] = useState('All');
  const [searchTerm, setSearchTerm] = useState('');
  const [hoveredCar, setHoveredCar] = useState(null);

  const filteredCars = cars.filter(car => {
    const matchesFilter = activeFilter === 'All' || car.type === activeFilter;
    const matchesSearch = car.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         car.type.toLowerCase().includes(searchTerm.toLowerCase());
    return matchesFilter && matchesSearch;
  });

  return (
    <div className="main-content" style={{ background: '#f5f6fa' }}>
      {/* Hero Section */}
      <div 
        className="tf-page-title"
        style={{
          background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%)',
          padding: '100px 0 120px',
          position: 'relative',
          overflow: 'hidden'
        }}
      >
        {/* Animated Shapes */}
        <div style={{
          position: 'absolute',
          top: '10%',
          left: '5%',
          width: '300px',
          height: '300px',
          background: 'radial-gradient(circle, rgba(237,184,8,0.1) 0%, transparent 70%)',
          borderRadius: '50%',
          animation: 'pulse 4s ease-in-out infinite'
        }}></div>
        <div style={{
          position: 'absolute',
          bottom: '20%',
          right: '10%',
          width: '400px',
          height: '400px',
          background: 'radial-gradient(circle, rgba(237,184,8,0.08) 0%, transparent 70%)',
          borderRadius: '50%',
          animation: 'pulse 4s ease-in-out infinite 1s'
        }}></div>
        
        <style>{`
          @keyframes pulse {
            0%, 100% { transform: scale(1); opacity: 0.8; }
            50% { transform: scale(1.1); opacity: 1; }
          }
          @keyframes float {
            0%, 100% { transform: translateY(0); }
            50% { transform: translateY(-10px); }
          }
          @keyframes slideUp {
            from { opacity: 0; transform: translateY(30px); }
            to { opacity: 1; transform: translateY(0); }
          }
        `}</style>

        <div className="themesflat-container full" style={{ position: 'relative', zIndex: 1 }}>
          <div className="page-title t-al-center" style={{ animation: 'slideUp 0.8s ease-out' }}>
            <span style={{ 
              color: '#edb808', 
              fontSize: '14px', 
              fontWeight: '600', 
              letterSpacing: '3px', 
              textTransform: 'uppercase',
              display: 'inline-block',
              marginBottom: '15px'
            }}>
              Premium Fleet
            </span>
            <h1 className="main-title" style={{ 
              color: 'white', 
              fontSize: '52px', 
              fontWeight: '800', 
              marginTop: '10px',
              marginBottom: '20px',
              textShadow: '0 4px 30px rgba(0,0,0,0.3)'
            }}>
              Our Car Collection
            </h1>
            <p style={{ 
              color: 'rgba(255,255,255,0.85)', 
              fontSize: '18px', 
              marginTop: '15px', 
              maxWidth: '700px', 
              margin: '15px auto 0',
              lineHeight: '1.7'
            }}>
              Discover our premium range of vehicles for every journey. From compact sedans to luxury vans, 
              we have the perfect ride for your travel needs.
            </p>
          </div>
        </div>
      </div>

      {/* Filter Section */}
      <section style={{ 
        padding: '0', 
        marginTop: '-60px', 
        position: 'relative', 
        zIndex: '10',
        marginBottom: '40px'
      }}>
        <div className="themesflat-container">
          <div style={{ 
            background: 'white', 
            borderRadius: '20px', 
            padding: '35px',
            boxShadow: '0 15px 50px rgba(0,0,0,0.12)'
          }}>
            {/* Search */}
            <div className="row align-items-center mb-4">
              <div className="col-lg-3">
                <div style={{ position: 'relative' }}>
                  <input
                    type="text"
                    placeholder="Search by car name..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    style={{
                      width: '100%',
                      padding: '9px 20px 9px 55px',
                      border: '2px solid #e8e8e8',
                      borderRadius: '12px',
                      fontSize: '15px',
                      transition: 'all 0.3s ease',
                      background: '#f8f9fa',
                      outline: 'none'
                    }}
                    onFocus={(e) => {
                      e.target.style.borderColor = '#edb808';
                      e.target.style.boxShadow = '0 0 0 4px rgba(237,184,8,0.1)';
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = '#e8e8e8';
                      e.target.style.boxShadow = 'none';
                    }}
                  />
                  <span style={{
                    position: 'absolute',
                    left: '20px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    color: '#999'
                  }}>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z" stroke="currentColor" strokeWidth="1.5"/>
                      <path d="M14 14L19 19" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                    </svg>
                  </span>
                </div>
              </div>
              <div className="col-lg-9">
                <div style={{ display: 'flex', gap: '10px',  justifyContent: 'flex-end' }}>
                  {carTypes.map(type => (
                    <button
                      key={type}
                      onClick={() => setActiveFilter(type)}
                      style={{
                        padding: '10px 22px',
                        border: 'none',
                        borderRadius: '30px',
                        fontSize: '14px',
                        fontWeight: '500',
                        cursor: 'pointer',
                        transition: 'all 0.3s ease',
                        background: activeFilter === type ? 'linear-gradient(135deg, #edb808 0%, #f5c518 100%)' : '#f0f2f5',
                        color: activeFilter === type ? '#1a1a2e' : '#666',
                        boxShadow: activeFilter === type ? '0 4px 15px rgba(237,184,8,0.4)' : 'none'
                      }}
                    >
                      {type}
                    </button>
                  ))}
                </div>
              </div>
            </div>
            
            {/* Results Count */}
            <div style={{ 
              display: 'flex', 
              alignItems: 'center', 
              gap: '10px',
              paddingTop: '15px',
              borderTop: '1px solid #f0f2f5'
            }}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="#edb808" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M2 17L12 22L22 17" stroke="#edb808" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M2 12L12 17L22 12" stroke="#edb808" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              <span style={{ color: '#666', fontSize: '14px' }}>
                Showing <strong style={{ color: '#1a1a2e' }}>{filteredCars.length}</strong> of {cars.length} vehicles
              </span>
            </div>
          </div>
        </div>
      </section>

      {/* Car List Section */}
      <section style={{ padding: '20px 0 80px' }}>
        <div className="themesflat-container">
          <div className="row">
            {filteredCars.map((car, index) => (
              <div key={car.id} className="col-lg-4 col-md-6 mb-35">
                <div 
                  style={{
                    background: 'white',
                    borderRadius: '20px',
                    overflow: 'hidden',
                    boxShadow: '0 10px 40px rgba(0,0,0,0.08)',
                    transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
                    height: '100%',
                    position: 'relative'
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.transform = 'translateY(-12px)';
                    e.currentTarget.style.boxShadow = '0 25px 60px rgba(0,0,0,0.15)';
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = '0 10px 40px rgba(0,0,0,0.08)';
                  }}
                >
                  {/* Image */}
                  <div style={{ 
                    background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%)',
                    padding: '40px 30px',
                    textAlign: 'center',
                    position: 'relative',
                    overflow: 'hidden'
                  }}>
                    {/* Decorative Circle */}
                    <div style={{
                      position: 'absolute',
                      top: '-50%',
                      right: '-30%',
                      width: '200px',
                      height: '200px',
                      background: 'radial-gradient(circle, rgba(255,255,255,0.08) 0%, transparent 70%)',
                      borderRadius: '50%'
                    }}></div>
                    <div style={{
                      position: 'absolute',
                      bottom: '-30%',
                      left: '-20%',
                      width: '150px',
                      height: '150px',
                      background: 'radial-gradient(circle, rgba(255,255,255,0.05) 0%, transparent 70%)',
                      borderRadius: '50%'
                    }}></div>
                    
                    {/* Type Badge */}
                    <div style={{
                      position: 'absolute',
                      top: '20px',
                      left: '20px',
                      background: '#edb808',
                      padding: '6px 14px',
                      borderRadius: '25px',
                      fontSize: '12px',
                      fontWeight: '700',
                      color: '#1a1a2e',
                      textTransform: 'uppercase',
                      letterSpacing: '1px',
                      zIndex: 2
                    }}>
                      {car.type}
                    </div>

                    {/* Favorite Button */}
                    <button style={{
                      position: 'absolute',
                      top: '20px',
                      right: '20px',
                      width: '40px',
                      height: '40px',
                      borderRadius: '50%',
                      border: 'none',
                      background: 'rgba(255,255,255,0.1)',
                      color: 'white',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      transition: 'all 0.3s ease',
                      zIndex: 2
                    }}
                    onMouseOver={(e) => e.target.style.background = 'rgba(255,255,255,0.2)'}
                    onMouseOut={(e) => e.target.style.background = 'rgba(255,255,255,0.1)'}
                    >
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 21.35L10.55 20.03C5.4 15.36 2 12.27 2 8.5C2 5.41 4.42 3 7.5 3C9.24 3 10.91 3.81 12 5.08C13.09 3.81 14.76 3 16.5 3C19.58 3 22 5.41 22 8.5C22 12.27 18.6 15.36 13.45 20.03L12 21.35Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    </button>

                    {/* Car Image */}
                    <div style={{ 
                      position: 'relative',
                      zIndex: 1,
                      animation: hoveredCar === car.id ? 'float 3s ease-in-out infinite' : 'none'
                    }}>
                      <img 
                        src={car.image} 
                        alt={car.name}
                        style={{ 
                          maxWidth: '100%', 
                          maxHeight: '140px',
                          objectFit: 'contain',
                          filter: 'drop-shadow(0 15px 30px rgba(0,0,0,0.4))',
                          transition: 'transform 0.4s ease'
                        }}
                        onMouseOver={() => setHoveredCar(car.id)}
                        onMouseOut={() => setHoveredCar(null)}
                      />
                    </div>
                  </div>

                  {/* Content */}
                  <div style={{ padding: '30px' }}>
                    <h3 style={{ 
                      fontSize: '22px', 
                      fontWeight: '700', 
                      color: '#1a1a2e',
                      marginBottom: '8px',
                      transition: 'color 0.3s ease',
                      cursor: 'pointer'
                    }}
                    onMouseOver={(e) => e.target.style.color = '#edb808'}
                    onMouseOut={(e) => e.target.style.color = '#1a1a2e'}
                    >
                      <Link to={car.link} style={{ textDecoration: 'none', color: 'inherit' }}>
                        {car.name}
                      </Link>
                    </h3>
                    
                    {/* Rating */}
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '15px' }}>
                      <div style={{ display: 'flex' }}>
                        {[1,2,3,4,5].map(star => (
                          <svg key={star} width="14" height="14" viewBox="0 0 24 24" fill="#edb808" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" />
                          </svg>
                        ))}
                      </div>
                      <span style={{ color: '#999', fontSize: '13px' }}>(5.0)</span>
                    </div>

                    {/* Features */}
                    <div style={{ 
                      display: 'grid', 
                      gridTemplateColumns: 'repeat(2, 1fr)',
                      gap: '10px',
                      marginBottom: '20px'
                    }}>
                      {car.features.slice(0, 4).map((feature, idx) => (
                        <div key={idx} style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '6px',
                          padding: '8px 12px',
                          background: '#f8f9fa',
                          borderRadius: '8px',
                          fontSize: '12px',
                          color: '#666'
                        }}>
                          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#22c55e" strokeWidth="2" xmlns="http://www.w3.org/2000/svg">
                            <polyline points="20 6 9 17 4 12"></polyline>
                          </svg>
                          {feature}
                        </div>
                      ))}
                    </div>

                    {/* Specs */}
                    <div style={{ 
                      display: 'flex', 
                      gap: '15px', 
                      marginBottom: '20px',
                      paddingBottom: '20px',
                      borderBottom: '1px solid #eee'
                    }}>
                      <div style={{ flex: 1, textAlign: 'center', padding: '10px', background: '#f8f9fa', borderRadius: '10px' }}>
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#edb808" strokeWidth="1.5" xmlns="http://www.w3.org/2000/svg" style={{ marginBottom: '5px' }}>
                          <path d="M12 2L2 7L12 12L22 7L12 2Z"/>
                          <path d="M2 17L12 22L22 17"/>
                          <path d="M2 12L12 17L22 12"/>
                        </svg>
                        <div style={{ fontSize: '12px', color: '#999', marginBottom: '2px' }}>Fuel</div>
                        <div style={{ fontSize: '13px', fontWeight: '600', color: '#1a1a2e' }}>{car.fuel.split('/')[0]}</div>
                      </div>
                      <div style={{ flex: 1, textAlign: 'center', padding: '10px', background: '#f8f9fa', borderRadius: '10px' }}>
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#edb808" strokeWidth="1.5" xmlns="http://www.w3.org/2000/svg" style={{ marginBottom: '5px' }}>
                          <path d="M17 21V19C17 17.9391 16.5786 16.9217 15.8284 16.1716C15.0783 15.4214 14.0609 15 13 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21"/>
                          <path d="M9 11C11.2091 11 13 9.20914 13 7C13 4.79086 11.2091 3 9 3C6.79086 3 5 4.79086 5 7C5 9.20914 6.79086 11 9 11Z"/>
                          <path d="M23 21V19C22.9993 18.1137 22.7044 17.2528 22.1614 16.5523C21.6184 15.8519 20.8581 15.3519 20 15.13"/>
                        </svg>
                        <div style={{ fontSize: '12px', color: '#999', marginBottom: '2px' }}>Seating</div>
                        <div style={{ fontSize: '13px', fontWeight: '600', color: '#1a1a2e' }}>{car.seating}</div>
                      </div>
                      <div style={{ flex: 1, textAlign: 'center', padding: '10px', background: '#f8f9fa', borderRadius: '10px' }}>
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#edb808" strokeWidth="1.5" xmlns="http://www.w3.org/2000/svg" style={{ marginBottom: '5px' }}>
                          <circle cx="12" cy="12" r="3"/>
                          <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"/>
                        </svg>
                        <div style={{ fontSize: '12px', color: '#999', marginBottom: '2px' }}>Trans.</div>
                        <div style={{ fontSize: '13px', fontWeight: '600', color: '#1a1a2e' }}>{car.transmission.split('/')[0]}</div>
                      </div>
                    </div>

                    {/* Price & CTA */}
                    <div style={{ 
                      display: 'flex', 
                      alignItems: 'center', 
                      justifyContent: 'space-between'
                    }}>
                      <div>
                        <span style={{ 
                          color: '#1a1a2e', 
                          fontSize: '13px',
                          fontWeight: '500'
                        }}>
                          Starting from
                        </span>
                        <div style={{ 
                          color: '#edb808', 
                          fontSize: '28px', 
                          fontWeight: '800',
                          lineHeight: '1.2'
                        }}>
                          {car.price.split('/')[0]}
                          <span style={{ fontSize: '14px', color: '#999', fontWeight: '500' }}>/day</span>
                        </div>
                      </div>
                      <div style={{ display: 'flex', gap: '10px' }}>
                        <Link 
                          to={car.link}
                          style={{
                            padding: '12px 20px',
                            background: '#f0f2f5',
                            color: '#1a1a2e',
                            border: 'none',
                            borderRadius: '12px',
                            fontSize: '14px',
                            fontWeight: '600',
                            cursor: 'pointer',
                            textDecoration: 'none',
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '6px',
                            transition: 'all 0.3s ease'
                          }}
                        >
                          Details
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M5 12H19M19 12L12 5M19 12L12 19"/>
                          </svg>
                        </Link>
                        <Link 
                          to={`/book-a-car`}
                          style={{
                            padding: '12px 24px',
                            background: 'linear-gradient(135deg, #edb808 0%, #f5c518 100%)',
                            color: '#1a1a2e',
                            border: 'none',
                            borderRadius: '12px',
                            fontSize: '14px',
                            fontWeight: '600',
                            cursor: 'pointer',
                            textDecoration: 'none',
                            transition: 'all 0.3s ease',
                            boxShadow: '0 4px 15px rgba(237,184,8,0.4)'
                          }}
                        >
                          Book Now
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {filteredCars.length === 0 && (
            <div style={{ 
              textAlign: 'center', 
              padding: '80px 0',
              background: 'white',
              borderRadius: '20px',
              boxShadow: '0 10px 40px rgba(0,0,0,0.08)'
            }}>
              <svg width="80" height="80" viewBox="0 0 24 24" fill="none" stroke="#ddd" strokeWidth="1.5" xmlns="http://www.w3.org/2000/svg" style={{ marginBottom: '25px' }}>
                <circle cx="11" cy="11" r="8"/>
                <path d="M21 21L16.65 16.65"/>
                <path d="M8 11H8.01"/>
                <path d="M11 8H11.01"/>
              </svg>
              <h3 style={{ marginBottom: '10px', color: '#1a1a2e', fontSize: '24px', fontWeight: '700' }}>No cars found</h3>
              <p style={{ color: '#666', fontSize: '16px', marginBottom: '25px' }}>
                Try adjusting your search or filter to find what you're looking for
              </p>
              <button 
                onClick={() => {setSearchTerm(''); setActiveFilter('All');}}
                style={{
                  padding: '12px 30px',
                  background: 'linear-gradient(135deg, #edb808 0%, #f5c518 100%)',
                  color: '#1a1a2e',
                  border: 'none',
                  borderRadius: '30px',
                  fontSize: '15px',
                  fontWeight: '600',
                  cursor: 'pointer'
                }}
              >
                Clear Filters
              </button>
            </div>
          )}
        </div>
      </section>

      {/* CTA Section */}
      <section style={{ 
        padding: '100px 0', 
        background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)',
        textAlign: 'center',
        position: 'relative',
        overflow: 'hidden'
      }}>
        {/* Animated Background */}
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'url("data:image/svg+xml,%3Csvg width=\'60\' height=\'60\' viewBox=\'0 0 60 60\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cg fill=\'none\' fill-rule=\'evenodd\'%3E%3Cg fill=\'%23edb808\' fill-opacity=\'0.05\'%3E%3Cpath d=\'M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z\'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")',
          opacity: 0.5
        }}></div>
        
        <div className="themesflat-container" style={{ position: 'relative', zIndex: 1 }}>
          <span style={{ 
            color: '#edb808', 
            fontSize: '14px', 
            fontWeight: '600', 
            letterSpacing: '3px', 
            textTransform: 'uppercase',
            display: 'inline-block',
            marginBottom: '20px'
          }}>
            Need Help?
          </span>
          <h2 style={{ 
            color: 'white', 
            fontSize: '42px', 
            fontWeight: '800', 
            marginBottom: '25px' 
          }}>
            Can't Find Your Perfect Car?
          </h2>
          <p style={{ 
            color: 'rgba(255,255,255,0.8)', 
            fontSize: '18px', 
            marginBottom: '40px',
            maxWidth: '600px',
            margin: '0 auto 40px',
            lineHeight: '1.7'
          }}>
            Our expert team is here to help you find the perfect vehicle for your needs. 
            Contact us now for personalized recommendations and special offers.
          </p>
          <div style={{ display: 'flex', gap: '20px', justifyContent: 'center', flexWrap: 'wrap' }}>
            <a 
              href="tel:+917801904444"
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '12px',
                padding: '18px 35px',
                background: '#edb808',
                color: '#1a1a2e',
                textDecoration: 'none',
                borderRadius: '50px',
                fontWeight: '700',
                fontSize: '16px',
                transition: 'all 0.3s ease',
                boxShadow: '0 10px 30px rgba(237,184,8,0.3)'
              }}
              onMouseOver={(e) => e.target.style.transform = 'translateY(-3px)'}
              onMouseOut={(e) => e.target.style.transform = 'translateY(0)'}
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
              </svg>
              Call Now: +91 7801904444
            </a>
            <Link 
              to="/contact"
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '12px',
                padding: '18px 35px',
                background: 'transparent',
                color: 'white',
                textDecoration: 'none',
                borderRadius: '50px',
                fontWeight: '700',
                fontSize: '16px',
                border: '2px solid rgba(255,255,255,0.3)',
                transition: 'all 0.3s ease'
              }}
              onMouseOver={(e) => {
                e.target.style.background = 'rgba(255,255,255,0.1)';
                e.target.style.borderColor = '#edb808';
              }}
              onMouseOut={(e) => {
                e.target.style.background = 'transparent';
                e.target.style.borderColor = 'rgba(255,255,255,0.3)';
              }}
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                <polyline points="22,6 12,13 2,6"/>
              </svg>
              Contact Us
            </Link>
          </div>
        </div>
      </section>

      {/* Mobile Responsive Styles */}
      <style>{`
        @media (max-width: 768px) {
          .tf-page-title { padding: 60px 0 80px !important; }
          .main-title { font-size: 32px !important; }
          .tf-page-title p { font-size: 16px !important; }
          .filter-section { padding: 20px !important; margin-top: -40px !important; }
          .filter-section input { padding: 8px 15px !important; font-size: 14px !important; }
          .filter-section button { padding: 8px 16px !important; font-size: 13px !important; }
          .tf-car-service { margin-bottom: 25px !important; }
          .tf-car-service .content { padding: 20px !important; }
          .tf-car-service h6 { font-size: 18px !important; }
          .tf-car-service .price { font-size: 18px !important; }
          .listing-information { font-size: 12px !important; }
          .widget-testimonial { padding: 40px 0 !important; }
          .widget-contact { padding: 40px 0 !important; }
          .contact-info-card { padding: 25px !important; }
          .contact-info-card h3 { font-size: 20px !important; }
          .footer-section { padding: 40px 0 20px !important; }
        }
        @media (max-width: 480px) {
          .main-title { font-size: 26px !important; }
          .filter-section { padding: 15px !important; }
          .filter-section .row { gap: 10px !important; }
          .tf-car-service .content h6 { font-size: 16px !important; }
        }
      `}</style>
    </div>
  );
};

export default CarList;
